module.exports = __webpack_public_path__ + "media/images/icons/flags/GQ-1fedd62a8244372240f1b6d8906ecc55.svg";